module.exports = require('../../full/map');
